import React from 'react';
import { Link } from 'react-router-dom';

const AttorneySingleDetailsOne = () => {
    return(
        <>
        {/*Attorney Single Section*/}
        <section className="attorney-single-section section-padding-default">
            <div className="default-container">
            <div className="row clerfix">
                <div className="col-md-8 order-md-2">
                <div className="attorney-single-details">
                    <div className="sec-o-title">
                    <h2>Biography</h2>
                    </div>
                    <div className="attorney-single-content">
                    <p>Lorem ipsum dolor sit amet, rcquisc adipiscing elit. Aenean socada commodo ligauala egets dssdolor. Aenean magsfssa. Cum socadaiis nato qfuae pentua ibaus et magnsfis dis parturient mon nascqetu rs idicfulus mus. Donefc
                        quamaem felis, ultriciddedes nec, pefflslen tesquwdfe eu, pr etium quis, sem.</p>
                    <p>Socadaiis nato qfuae pent ibaus et magnsfis dis parturient mon tes, nascqetur rsidicful muss enean magsfssad. Cum socadaiis nato qfuae pent ibaus et magnsfis dis parturient mon tes, nascqetur rsidicfulus mus. Donefc qua
                        maem felis, ultriciddedes nec, pefflsl tesquwdfe eu, pr etium quis, sem.</p>
                    <p>Dascqetur rsidicfulus mus donefc quamaem felis, ultriciddedes nec, pefflsl tesquwdfe eu, pr etium quis, fasem. Cum socadaiis nato qfuae pent ibaus et magnsfis dis parturient mon tes, nascqetur rsidicfulus mus. Cum socadaiis
                        nato qfuae pent ibaus et magnsfis dis socad. Socadaiis nato qfuae pent ibaus et magnsfis dis parturient mon tes, nascqetur rsidicful muss enean magsfssa.</p>
                    </div>
                    <div className="edu-list  mt-4">
                    <div className="sec-o-title">
                        <h2>Education</h2>
                    </div>
                    <div className="education-details">
                        <div className="education-title">
                        <h4>DistinctCoder University of Los Angeles</h4>
                        </div>
                        <div className="pass-years mb-2">2008-2012</div>
                        <p>Sigh view am high neat half to what. Sent late held than set why wife our. If an blessing building steepest.</p>
                    </div>
                    <div className="education-details">
                        <div className="education-title">
                        <h4>DistinctCoder University of Los Angeles</h4>
                        </div>
                        <div className="pass-years mb-2">2008-2012</div>
                        <p>Sigh view am high neat half to what. Sent late held than set why wife our. If an blessing building steepest.</p>
                    </div>
                    </div>
                    <div className="prac-areas-list mt-4">
                    <div className="row clearfix">
                        <div className="col-lg-12">
                        <div className="sec-o-title">
                            <h2>Education</h2>
                        </div>
                        </div>
                        <div className="col-lg-6">
                        <ul>
                            <li className="attorney-category">
                            <Link to="#">Property Law</Link>
                            </li>
                            <li className="attorney-category">
                            <Link to="#">Finance &amp; Security Law</Link>
                            </li>
                            <li className="attorney-category">
                            <Link to="#">Corporate Law</Link>
                            </li>
                            <li className="attorney-category">
                            <Link to="#">Criminal Defence Law</Link>
                            </li>
                            <li className="attorney-category">
                            <Link to="#">Serious Car Crash</Link>
                            </li>
                            <li className="attorney-category">
                            <Link to="#">Child Labor</Link>
                            </li>
                            <li className="attorney-category">
                            <Link to="#">Justice Fight</Link>
                            </li>
                            <li className="attorney-category">
                            <Link to="#">Family Law</Link>
                            </li>
                        </ul>
                        </div>
                        <div className="col-lg-6">
                        <ul>
                            <li className="attorney-category">
                            <Link to="#">Property Law</Link>
                            </li>
                            <li className="attorney-category">
                            <Link to="#">Finance &amp; Security Law</Link>
                            </li>
                            <li className="attorney-category">
                            <Link to="#">Corporate Law</Link>
                            </li>
                            <li className="attorney-category">
                            <Link to="#">Criminal Defence Law</Link>
                            </li>
                            <li className="attorney-category">
                            <Link to="#">Serious Car Crash</Link>
                            </li>
                            <li className="attorney-category">
                            <Link to="#">Child Labor</Link>
                            </li>
                            <li className="attorney-category">
                            <Link to="#">Justice Fight</Link>
                            </li>
                            <li className="attorney-category">
                            <Link to="#">Family Law</Link>
                            </li>
                        </ul>
                        </div>
                    </div>
                    </div>
                    <div className="hon-awa-list mt-4">
                    <div className="sec-o-title mb-5">
                        <h3>Honors and Awards</h3>
                    </div>
                    <div className="hon-awa-details mt-3">
                        <i className="fa fa-shield" />
                        <div className="hon-awa-det">
                        <div className="hon-awa-title">
                            <h4>2012 Life Time Achievement Award</h4>
                        </div>
                        <p>Sigh view am high neat half to what. Sent late held than set why wife our. If an blessing building steepest.</p>
                        </div>
                    </div>
                    <div className="hon-awa-details mt-3">
                        <i className="fa fa-shield" />
                        <div className="hon-awa-det">
                        <div className="hon-awa-title">
                            <h4>2012 Life Time Achievement Award</h4>
                        </div>
                        <p>Sigh view am high neat half to what. Sent late held than set why wife our. If an blessing building steepest.</p>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
                <div className="col-md-4 order-md-1">
                <div className="attorney-single-img">
                    <img src="images/attorneys/at-01-445x472.png" alt="attorney" />
                </div>
                <div className="attorney-single-continfo mt-5">
                    <div className="sec-o-title pb-2">
                    <h3>Contact Information</h3>
                    </div>
                    <div className="attorney-single-phone">
                    <i className="fa fa-phone" />
                    <div className="atto-cont-det">
                        <p><span>Phone:</span> <Link to="tal:+67898752235">+6789-875-2235</Link></p>
                        <p><span>Fax:</span> +6789-875-2235</p>
                    </div>
                    </div>
                    <div className="attorney-single-email">
                    <i className="fa fa-envelope" />
                    <div className="atto-cont-det">
                        <p><span>Email:</span>
                        <Link to="mailto:Support@domainname.com"> Support@domainname.com</Link></p>
                        <p><span>Website:</span> <Link to="#"> www.companydomain.com</Link></p>
                    </div>
                    </div>
                    <div className="attorney-single-email">
                    <i className="fa fa-map-marker" />
                    <div className="atto-cont-det">
                        <p><span>Address:</span> 202 New Hampshire Avenue</p>
                        <p>Northwest #100, New York-2573</p>
                    </div>
                    </div>
                </div>
                <div className="attorney-single-contform mt-5">
                    <div className="sec-o-title pb-2">
                    <h3>Contact Me</h3>
                    </div>
                    <div className="attorney-single-form">
                    <form action="#">
                        <div className="form-group"><input className="form-control input-style-one" type="text" placeholder="Name" /></div>
                        <div className="form-group"><input className="form-control input-style-one" type="email" placeholder="Email" /></div>
                        <div className="form-group"><textarea className="form-control input-style-one" placeholder="Your Message" defaultValue={""} /></div>
                        <div className="form-group"><input className="btn btn_custom corpo-r-btn btn-style-two" type="submit" defaultValue="SUBMIT MESSAGE" /></div>
                    </form>
                    </div>
                </div>
                <div className="attorney-single-social mt-5">
                    <div className="attorney-single-sociallink">
                    <span className="title">share :</span>
                    <Link to="#" className="blog-det-social">
                        <i className="fa fa-facebook" />
                    </Link>
                    <Link to="#" className="blog-det-social">
                        <i className="fa fa-pinterest-p" />
                    </Link>
                    <Link to="#" className="blog-det-social">
                        <i className="fa fa-linkedin" />
                    </Link>
                    <Link to="#" className="blog-det-social">
                        <i className="fa fa-instagram" />
                    </Link>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </section>
        {/*End Attorney Single Section*/}
        </>
    )
}

export default AttorneySingleDetailsOne;